import type { SiteSnapshot } from "../lib/api";

interface Props {
  snapshots: SiteSnapshot[];
  field: "visits" | "uniqueVisitors" | "pageviews";
  width?: number;
  height?: number;
}

export function Sparkline({
  snapshots,
  field,
  width = 120,
  height = 28,
}: Props) {
  if (snapshots.length < 2) {
    return (
      <svg width={width} height={height} className="text-whisper">
        <line
          x1={0}
          y1={height / 2}
          x2={width}
          y2={height / 2}
          stroke="currentColor"
          strokeWidth={1}
          strokeDasharray="2 4"
        />
      </svg>
    );
  }

  const values = snapshots.map((s) => s[field]);
  const max = Math.max(...values, 1);
  const min = Math.min(...values, 0);
  const range = max - min || 1;

  const stepX = width / (values.length - 1);
  const points = values.map((v, i) => {
    const x = i * stepX;
    const y = height - ((v - min) / range) * (height - 2) - 1;
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  });

  const pathD = `M${points.join(" L")}`;
  const lastY =
    height - ((values[values.length - 1] - min) / range) * (height - 2) - 1;

  return (
    <svg width={width} height={height} className="overflow-visible text-ink">
      <path
        d={pathD}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={width} cy={lastY} r={2} fill="currentColor" />
    </svg>
  );
}
